/**
 * THE NODE CONTRACT — the shape every piece of hierarchical content takes, from a region down to a
 * room. See docs/hierarchical-region-system.md §3.1.
 *
 * The whole design is one observation: `MAX_FOLD_LOD` / `MAX_SCATTER_LOD` / `StampSpec.maxLod` are
 * already a ONE-LEVEL answer to "how far down do I have to look to draw this correctly at this
 * distance?". A node generalises that to a tree, and the per-kind LOD cutoffs are the entire
 * efficiency story: `expandAtLod` decides how deep the walk goes, so a chunk 2 km away expands a
 * region and stops, while the chunk you are standing in expands the room you are standing in.
 *
 * TWO THINGS ARE LOAD-BEARING and are worth stating before any kind is written.
 *
 * `aabb` PRUNES THE WALK AND FEEDS THE CLIP. A node that draws one voxel outside its declared bounds
 * produces a hole that appears at one LOD, at one chunk boundary, for one seed — the least debuggable
 * class of defect this system can have. It must be conservative and it must be known WITHOUT
 * expanding children.
 *
 * `ySpan` MUST NOT FORCE EXPANSION. `generateLodColumn` is analytic: it decides which chunks exist
 * before any of them is generated. A tower has to be able to say how tall it is from its seed and the
 * terrain under its footprint, without enumerating sixty floors to find out.
 */
export function aabbOverlaps(a, b) {
    return a.minX < b.maxX && a.maxX > b.minX
        && a.minY < b.maxY && a.maxY > b.minY
        && a.minZ < b.maxZ && a.maxZ > b.minZ;
}
//# sourceMappingURL=NodeTypes.js.map